<template>
    <section
        ref="section6"
        :class="[
            Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
            'mx-auto flex h-full flex-col',
        ]"
    >
        <v-add-listing-head :routes="routes" :step="6"></v-add-listing-head>
        <main
            class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
        >
            <figure class="flex max-w-lg flex-col gap-11 lg:w-full">
                <figure class="flex gap-3">
                    <div><v-icon icon="tag" size="8"></v-icon></div>
                    <div class="flex flex-col justify-center">
                        <div class="text-heading-3-desktop">
                            Po kakšni ceni prodajate nepremičnino?
                        </div>
                    </div>
                </figure>
                <form
                    method="POST"
                    :action="routes.submitForm"
                    id="select-pricing"
                >
                    <v-csrf-token></v-csrf-token>

                    <figure
                        class="ml-auto mr-auto flex w-full max-w-lg flex-col gap-8"
                        v-if="stepData.vermarktungsart == 'kauf'"
                    >
                        <ul class="flex flex-col gap-8">
                            <li class="w-full">
                                <div
                                    :class="[
                                        'input group relative relative flex flex-col gap-[10px]',
                                        validationErrors.preis
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                >
                                    <label
                                        for="addPrice"
                                        class="w-full text-body-medium-button"
                                    >
                                        <div
                                            class="label flex flex-col gap-[10px]"
                                        >
                                            <div
                                                class="flex items-center gap-3"
                                            >
                                                <v-icon
                                                    icon="euro"
                                                    size="4"
                                                ></v-icon>
                                                <span>
                                                    Ponudbena cena
                                                    <sup>*</sup></span
                                                >
                                            </div>
                                        </div>
                                    </label>
                                    <input
                                        id="addPrice"
                                        type="text"
                                        name="preis"
                                        placeholder="Ponudbena cena"
                                        v-model="price"
                                    />
                                    <span
                                        class="absolute bottom-[18px] right-6 text-body-medium-button"
                                        :class="price ? 'text-black-78' : 'text-black-40'"
                                        >€</span
                                    >
                                </div>
                            </li>
                            <li class="w-full">
                                <v-checkbox
                                    label="Brez provizije"
                                    checkbox-position="right"
                                    name="brezProvizije"
                                    :checked="Boolean(provisionCasted)"
                                    icon="add-card"
                                    @vchanged="provision = !provision"
                                ></v-checkbox>
                            </li>
                            <li v-show="!Boolean(provisionCasted)" class="w-full">
                                <div
                                    :class="[
                                        'textarea group flex items-center',
                                        validationErrors.preis
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                >
                                    <label
                                        for="visinaProvizijeZaKupca"
                                        class="flex w-full flex-col gap-[10px] text-body-medium-button"
                                    >
                                        <div class="label flex flex-col gap-10">
                                            <div class="flex items-start gap-3">
                                                <v-icon icon="percent"></v-icon>
                                                <div
                                                    class="flex flex-col gap-[10px]"
                                                >
                                                    <div>
                                                        Višina provizije za
                                                        kupca
                                                    </div>
                                                    <small
                                                        class="text-body-regular text-black-40"
                                                        >Opišite podrobno višino
                                                        provizije v %, z ali
                                                        brez DDV-ja in pogoje
                                                        plačila
                                                        provizije.</small
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <textarea
                                            id="visinaProvizijeZaKupca"
                                            name="aussen_courtage"
                                            placeholder="Višina provizije za kupca"
                                            rows="10"
                                            class="pl-7"
                                            v-model="provisionAmount"
                                        ></textarea>
                                        <small
                                            class="flex w-full justify-end text-small-text-regular text-black-40"
                                            >0/80 besed</small
                                        >
                                    </label>
                                </div>
                            </li>
                        </ul>
                        <input
                            type="text"
                            name="provisionsfrei"
                            class="hidden"
                            v-model="provisionCasted"
                        />
                    </figure>

                    <figure
                        class="ml-auto mr-auto max-w-lg"
                        v-if="stepData.vermarktungsart == 'miete'"
                    >
                        <ul
                            class="grid grid-cols-4 flex-col gap-x-5 gap-y-8"
                        >
                            <li class="col-span-4">
                                <div
                                    :class="[
                                        'input group relative flex flex-col gap-[10px]',
                                        validationErrors.kaltmiete
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                >
                                    <label
                                        for="netoNajemnina"
                                        class="w-full text-body-medium-button"
                                    >
                                        <div
                                            class="label flex flex-col gap-[10px]"
                                        >
                                            <div
                                                class="flex items-center gap-3"
                                            >
                                                <v-icon
                                                    icon="payments"
                                                    size="4"
                                                ></v-icon>
                                                <span>
                                                    <span v-text="stepData.kaltmieteLabel"></span>
                                                    <sup>*</sup>
                                                </span>
                                            </div>
                                        </div>
                                    </label>
                                    <input
                                        id="netoNajemnina"
                                        type="number"
                                        name="kaltmiete"
                                        :placeholder="stepData.kaltmieteLabel"
                                        v-model="
                                            kaltmiete
                                        "
                                    />
                                    <div
                                        class="absolute bottom-[18px] right-6 text-body-medium-button"
                                        :class="kaltmiete ? 'text-black-78' : 'text-black-40'"
                                        >€/mesec</div
                                    >
                                </div>
                            </li>
                            <li class="col-span-4">
                                <div
                                    :class="[
                                        'input group relative flex flex-col gap-[10px]',
                                        validationErrors.warmmiete
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                >
                                    <label
                                        for="netoNajemnina"
                                        class="w-full text-body-medium-button"
                                    >
                                        <div
                                            class="label flex flex-col gap-[10px]"
                                        >
                                            <div
                                                class="flex items-center gap-3"
                                            >
                                                <v-icon
                                                    icon="payments"
                                                    size="4"
                                                ></v-icon>
                                                <span>
                                                    <span v-text="stepData.warmmieteLabel"></span>
                                                    <sup>*</sup></span
                                                >
                                            </div>
                                        </div>
                                    </label>
                                    <input
                                        id="brutoNajemnina"
                                        type="number"
                                        name="warmmiete"
                                        :placeholder="stepData.warmmieteLabel"
                                        v-model="
                                            warmmiete
                                        "
                                    />
                                    <div
                                        class="absolute bottom-[18px] right-6 text-body-medium-button"
                                        :class="warmmiete ? 'text-black-78' : 'text-black-40'"
                                        >€/mesec</div
                                    >
                                </div>
                            </li>
                        </ul>
                    </figure>

                </form>
            </figure>
        </main>
        <v-add-listing-foot>
            <a
                @click="submitForm('select-pricing')"
                :class="['button button--md h-[48px] w-[240px] px-6', (validated ? '' : 'button button--gray')]"
            >
                <label class="text-small-text-medium">Nadaljujte</label>
                <v-icon icon="arrow-right" size="4"></v-icon>
            </a>
        </v-add-listing-foot>
    </section>
</template>
<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
    },

    props: {
        old: {
            type: Object,
            required: false,
            default: {},
        },
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
    },
    data() {
        return {
            price: null,
            provision: false,
            provisionAmount: null,
            kaltmiete: null,
            warmmiete: null,
        };
    },
    computed: {
        provisionCasted() {
            return this.provision ? 1 : 0;
        },
        validated() {
            if(this.stepData.vermarktungsart == 'kauf') {
                if(!this.price) return false

                if(this.provisionCasted == 0 && !this.provisionAmount) return false

                return true;
            }

            if(this.stepData.vermarktungsart == 'miete') {
                if(!this.kaltmiete || !this.warmmiete) return false
            }

            return true
        }
    },
    mounted() {
        //this.stepData.vermarktungsart
        this.price =(this.old.preis ? this.old.preis : this.stepData.preis)
        this.provision =(this.old.provisionsfrei ? this.old.provisionsfrei : this.stepData.provisionsfrei)
        this.provisionAmount =(this.old.aussen_courtage ? this.old.aussen_courtage : this.stepData.aussen_courtage)
        this.kaltmiete =(this.old.kaltmiete ? this.old.kaltmiete : this.stepData.kaltmiete)
        this.warmmiete =(this.old.warmmiete ? this.old.warmmiete : this.stepData.warmmiete)
    },
    methods: {
        submitForm(formId) {
            if(this.validated) document.getElementById(formId).submit();
        },
    }
};
</script>
